const SHORT_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const LONG_MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
];
function parts(value) {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [y, m, d] = value.split('-').map(Number);
        return { y, m: m - 1, d };
    }
    const date = typeof value === 'string' ? new Date(value) : value;
    return { y: date.getFullYear(), m: date.getMonth(), d: date.getDate() };
}
export function formatDate(value) {
    const { y, m, d } = parts(value);
    return `${d} ${SHORT_MONTHS[m]} ${y}`;
}
export function formatLongDate(value) {
    const { y, m, d } = parts(value);
    return `${d} ${LONG_MONTHS[m]} ${y}`;
}
export function formatDateTime(value) {
    const date = typeof value === 'string' ? new Date(value) : value;
    const hh = String(date.getHours()).padStart(2, '0');
    const mm = String(date.getMinutes()).padStart(2, '0');
    return `${formatDate(date)}, ${hh}:${mm}`;
}
export function isoDay(value) {
    const y = value.getFullYear();
    const m = String(value.getMonth() + 1).padStart(2, '0');
    const d = String(value.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
}
//# sourceMappingURL=format.js.map